'use client'

import { navigateToPage } from '@marketplace-web/shared/browser-util'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import { clickEvent } from '@marketplace-web/complaints/complaints-data'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { COMPLAINT_URL } from '../../constants/routes'

type Props = ConversationActionProps

const ViewComplaint = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { transaction } = useConversationContext()

  const handleClick = () => {
    if (!transaction?.complaintId) return

    navigateToPage(COMPLAINT_URL(transaction.complaintId))

    const targetDetails = {
      transaction_id: transaction?.id,
    }

    track(
      clickEvent({
        target: 'view_complaint',
      }),
    )

    track(
      clickEvent({
        target: 'view_issue_details',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  if (!transaction?.id || !transaction.complaintId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="view-complaint-action-button"
    />
  )
}

export default ViewComplaint
